import React, { useEffect, useState } from "react";
import { buyListedLand } from "../contractInteraction/contractInteraction";
import { useAccount, useWalletClient } from "wagmi";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import { firestoredb } from "../../firebase/firebase";
import "./listedcard.css";

const ListedCard = ({ item, imageSrc }) => {
  const { data: signer } = useWalletClient();
  const { address } = useAccount();
  const [balance, setBalance] = useState("");
  // const buyFunc = async () => {
  //   const price = 100;
  //   // console.log(value);
  //   console.log(item);
  //   if (address) {
  //     await buyLandC(value.finalPrice, value.randomNumber, item, signer, address)
  //       .then((res) => {
  //         console.log(res);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // };

  const handleBuyListedLand = async (price, tokenId, mapNumber, coordinate) => {
    console.log("month", tokenId);
    console.log("price", price);
    console.log("map", mapNumber);
    console.log("Coordinate", coordinate);
    buyListedLand(price, tokenId, signer).then(async (res) => {
      console.log(res);
      if (res.success) {

        await setDoc(
          doc(firestoredb, "map", mapNumber),
          {
            [coordinate]: {
              listRented: false
            },
          },
          { merge: true }
        ).then(res => console.log(res))
          .catch((err) => {
            console.log(err);
          });

      }
    }).catch(err => {
      console.log(err);
    })
  }


  return (
    <div>
      <div className="land-listed-card">
        <div className="recent-listing-card-image">
          <img
            src={imageSrc}
            alt="PlayerPlot"
          />

          <div className="card-body">
            <p>Price</p>
            <div className="price-time">
              <h3>USDT {item.listPrice}</h3>
              <p>10 minutes ago</p>
            </div>
          </div>
        </div>
        <div className="last-portion">
          <div className="player-name">
            <h3>{item.coordinate}</h3>
            <p>size: {item.data.size}</p>
          </div>
          <button className="buy-btn" onClick={() => handleBuyListedLand(item.listPrice, item.tokenId, item.mapNumber[0], item.coordinate)}>
            BUY
          </button>
        </div>
      </div>
    </div>
  );
};

export default ListedCard;
